<template>
  <div class="mobile-contact-info">
    <div class="contact-container">
      <div class="contact-header">
        <h2 class="contact-title">{{ t('home.contactinfo.title') }}</h2>
      </div>
      
      <div class="contact-content">
        <!-- 基本联系信息 -->
        <div class="contact-basic">
          <div class="contact-item">
            <div class="contact-icon">
              <i class="icon-location">📍</i>
            </div>
            <div class="contact-text">
              <div class="contact-value">{{ t('home.contactinfo.addressmobile') }}</div>
            </div>
          </div>
          
          <div class="contact-item">
            <div class="contact-icon">
              <i class="icon-phone">📞</i>
            </div>
            <div class="contact-text">
              <div class="email-item">{{ t('home.contactinfo.sales') }}</div>
            <div class="email-item">{{ t('home.contactinfo.hr') }}</div>
            </div>
          </div>
          
          <div class="contact-item">
            <div class="contact-icon">
              <i class="icon-email">✉</i>
            </div>
            <div class="contact-text">
              <div class="contact-value">
                <div class="email-item">{{ t('home.contactinfo.sales') }}</div>
            <div class="email-item">{{ t('home.contactinfo.hr') }}</div>
            <div class="email-item">{{ t('home.contactinfo.inquiry') }}</div>
            <div class="email-item">{{ t('home.contactinfo.inspection') }}</div></div>
            </div>
          </div>
        </div>
        
        
        <!-- 微信二维码 -->
        <div class="wechat-section">
          <h3 class="section-title">关注我们</h3>
          <div class="qrcode-container">
            <div class="qrcode-item">
              <img src="/images/wx/上海超导-服务号二维码20250327.jpg" alt="服务号" class="qrcode-img">
              <div class="qrcode-label">{{ t('home.contactinfo.serviceAccount') }}</div>
            </div>
            <div class="qrcode-item">
              <img src="/images/wx/上海超导SST-订阅号二维码20250327.jpg" alt="订阅号" class="qrcode-img">
              <div class="qrcode-label">{{ t('home.contactinfo.subscriptionAccount') }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<style scoped lang="scss">
.mobile-contact-info {
  background: linear-gradient(135deg, #f5f7fa 0%, #c3cfe2 100%);
  padding: 40px 0;
}

.contact-container {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 20px;
}

.contact-header {
  text-align: center;
  margin-bottom: 30px;
}

.contact-title {
  font-size: 28px;
  font-weight: 700;
  color: #333;
  margin: 0;
  text-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.contact-content {
  background: #fff;
  border-radius: 16px;
  padding: 30px 20px;
  box-shadow: 0 10px 30px rgba(0, 0, 0, 0.1);
}

.contact-basic {
  margin-bottom: 30px;
}

.contact-item {
  display: flex;
  align-items: center;
  margin-bottom: 20px;
  padding: 15px;
  background: #f8f9fa;
  border-radius: 12px;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e9ecef;
    transform: translateY(-2px);
  }
}

.contact-icon {
  width: 50px;
  height: 50px;
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  border-radius: 12px;
  margin-right: 15px;
  
  i {
    font-size: 20px;
    color: #fff;
  }
}

.contact-text {
  flex: 1;
}

.contact-label {
  font-size: 12px;
  color: #666;
  font-weight: 500;
  margin-bottom: 4px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.contact-value {
  font-size: 14px;
  color: #333;
  font-weight: 600;
  line-height: 1.4;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #333;
  margin-bottom: 15px;
  text-align: center;
  position: relative;
  
  &::after {
    content: '';
    position: absolute;
    bottom: -5px;
    left: 50%;
    transform: translateX(-50%);
    width: 40px;
    height: 2px;
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  }
}

.email-section {
  margin-bottom: 30px;
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.email-list {
  display: grid;
  gap: 10px;
}

.email-item {
  padding: 12px 15px;
  background: #f8f9fa;
  border-radius: 8px;
  font-size: 14px;
  color: #333;
  transition: all 0.3s ease;
  
  &:hover {
    background: #e9ecef;
    transform: translateX(4px);
  }
}

.wechat-section {
  padding-top: 20px;
  border-top: 1px solid #eee;
}

.qrcode-container {
  display: flex;
  justify-content: space-around;
  gap: 20px;
}

.qrcode-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  flex: 1;
}

.qrcode-img {
  width: 100px;
  height: 100px;
  border-radius: 12px;
  border: 3px solid #fff;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.1);
  transition: all 0.3s ease;
  
  &:hover {
    transform: scale(1.05);
    box-shadow: 0 6px 20px rgba(0, 0, 0, 0.15);
  }
}

.qrcode-label {
  color: #666;
  font-size: 14px;
  font-weight: 500;
  margin-top: 10px;
  text-align: center;
}

@media screen and (max-width: 480px) {
  .mobile-contact-info {
    padding: 30px 0;
  }
  
  .contact-container {
    padding: 0 15px;
  }
  
  .contact-title {
    font-size: 24px;
  }
  
  .contact-content {
    padding: 25px 15px;
  }
  
  .contact-item {
    padding: 12px;
  }
  
  .contact-icon {
    width: 45px;
    height: 45px;
    margin-right: 12px;
    
    i {
      font-size: 18px;
    }
  }
  
  .contact-value {
    font-size: 13px;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .email-item {
    padding: 10px 12px;
    font-size: 13px;
  }
  
  .qrcode-container {
    gap: 15px;
  }
  
  .qrcode-img {
    width: 80px;
    height: 80px;
  }
  
  .qrcode-label {
    font-size: 12px;
    margin-top: 8px;
  }
}

@media screen and (max-width: 360px) {
  .contact-title {
    font-size: 22px;
  }
  
  .contact-content {
    padding: 20px 12px;
  }
  
  .qrcode-img {
    width: 70px;
    height: 70px;
  }
}
</style> 